import(/* webpackMode: "eager" */ "C:\\Users\\nahus\\Desktop\\VQBITs\\KaryaAyojak\\frontend\\src\\app\\page.tsx");
